import React, { useState } from 'react'
import { Table, Tooltip, Skeleton, Empty, message, DatePicker, Modal, Button } from "antd";
import useAxiosInstance from '../../../lib/useAxiosInstance';
import * as XLSX from 'xlsx';

const { RangePicker } = DatePicker;
const { Column } = Table;

const GmsClientDataTable = ({ pagination, SearchGmsClientData, allGmsData, getClientById, ShowGmsEditModal }) => {
    const [isDownloadModalVisible, setIsDownloadModalVisible] = useState(false);
    const [selectedClientId, setSelectedClientId] = useState(null);
    const [dateRange, setDateRange] = useState(null);
    const isLoading = allGmsData.isLoading || SearchGmsClientData?.isLoading;
    const axiosInstance = useAxiosInstance();

    const handleDownloadClick = (clientId) => {
        setSelectedClientId(clientId);
        setIsDownloadModalVisible(true);
    };

    const handleDownload = async () => {
        try {
            if (!dateRange) {
                message.warning('Please select a date range');
                return;
            }

            const [startDate, endDate] = dateRange;
            const url = `api/grievances/GrievanceForDownloadByAdmin/${selectedClientId}`;

            const response = await axiosInstance.post(url, {
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            });

            if (response.data.status && response.data.data.length > 0) {
                // Transform data for Excel export (same as before)
                const excelData = response.data.data.map((grievance) => ({
                    'Grievance ID': grievance._id,
                    'Title': grievance.grievanceTitle || 'No Title',
                    'Description': grievance.description,
                    'Status': grievance.status,
                    'Created By': grievance.createdByUserName,
                    'Visitor Type': grievance.visitorType,
                    'Visitor Name':grievance.fullName,
                    'Visitor Email':grievance.email,
                    'Gender':grievance.gender,
                    'Mobile Number':grievance.phone,
                    'Category': grievance.categoryName,
                    'Sub Category': grievance.subCategoryName,
                    'Priority': grievance.priority,
                    'Constituency': grievance.constituencyName,
                    'Office Name': grievance.office?.name,
                    'Office Address': grievance.office?.address,
                    'Location': grievance.location
                        ? `Lat: ${grievance.location.lat}, Lng: ${grievance.location.lng}, Address: ${grievance.location.address}`
                        : 'No Location',
                    'Created At': new Date(grievance.createdAt).toLocaleString(),
                }));

                // Create worksheet
                const worksheet = XLSX.utils.json_to_sheet(excelData);

                // Create workbook and add worksheet
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Grievances');

                // Generate Excel file
                XLSX.writeFile(workbook, `Grievances_${selectedClientId}_${startDate.format('YYYYMMDD')}_${endDate.format('YYYYMMDD')}.xlsx`);

                message.success('Grievances downloaded successfully');
                setIsDownloadModalVisible(false);
            } else {
                message.warning('No grievances found to download');
            }
        } catch (error) {
            console.error('Download error:', error);
            message.error( error?.response?.data?.error || 'Failed to download grievances');
        }
    };



    return (
        <>
            <div className="gms-client-table">
                <Table rowKey={(record) => record._id} className="gms-table-rows" pagination={pagination}
                    dataSource={SearchGmsClientData || allGmsData?.data?.data?.data}
                    locale={{
                        emptyText: isLoading ? (
                            <div
                                style={{
                                    marginLeft: "20px",
                                    width: "95%"
                                }}
                            >
                                {" "}
                                {/* Container with 90% width */}
                                <Skeleton
                                    title={false}
                                    active
                                    paragraph={{
                                        rows: 6,
                                        width: ["100%", "100%", "100%", "100%", "100%", "100%"]
                                    }}
                                />
                            </div>
                        ) : (
                            <Empty />
                        )
                    }}
                >
                    {/* <Column title="CLIENT ID" dataIndex="_id"
                        render={(_id) => (
                            <Tooltip title={_id}>
                                {`${_id.slice(0, 10)}${_id.length > 10 ? "..." : ""}`}
                            </Tooltip>
                        )}
                    /> */}
                    <Column
                        key="client-id"
                        title="CLIENT ID"
                        render={(text, record) => (
                            <span>{`#${record.customClientId}`}</span>
                        )}
                    />
                    <Column title="CLIENT NAME" dataIndex="name"
                        render={(text, record) => (
                            <span onClick={() => {
                                ShowGmsEditModal(record);
                                getClientById(record._id);
                            }}>
                                {`${record?.adminFirstName} ${record?.adminLastName}`}
                            </span>
                        )}
                    />
                    <Column key="state" title="State" dataIndex="constituencyName"
                        render={(text, record) =>
                            record.constituency.map((c) => c.constituencyState).join(", ")
                        }
                    />
                    {/* <Column title="SUBSCRIPTION" dataIndex="planDetails"
                        render={(planDetails) => {
                            return planDetails?.name;
                        }}
                /> */}

                    <Column
                        key='subscription'
                        title='SUBSCRIPTION'
                        dataIndex='planType'
                        render={(text, record) =>
                            record.planType.map((plan) => plan.name).join(", ")
                        }
                    />

                    <Column title="NO. OF OFFICES" dataIndex="clientOfficeCount" className="custom-sorter w-48"
                        sorter={(a, b) => a.clientOfficeCount - b.clientOfficeCount} sortDirections={["ascend", "descend"]}
                        render={(clientOfficeCount) => {
                            return clientOfficeCount;
                        }}
                    />
                    <Column title="CONSTITUENCY" dataIndex="constituencyName"
                        render={(constituency, record, index) => (
                            <span>
                                {`${record?.constituency[0]?.constituencyName}
                            ${record.constituency?.length > 1 ? ` +${record.constituency.length - 1}` : ""}`}
                            </span>
                        )}
                    />
                    <Column title="NO. OF GRIEVANCE" dataIndex="grievances_count" className="custom-sorter w-52"
                        sorter={(c, d) => c.grievances_count - d.grievances_count} sortDirections={["ascend", "descend"]}
                        render={(grievances_count) => {
                            return grievances_count;
                        }}
                    />
                    <Column
                        title="DOWNLOAD"
                        dataIndex="_id"
                        className="w-52"
                        render={(clientId, record) => (
                            <button
                                disabled={record.grievances_count === 0}
                                onClick={() => handleDownloadClick(clientId)}
                                className={`
                                    ${record.grievances_count === 0
                                        ? 'bg-blue-200 cursor-not-allowed'
                                        : 'bg-blue-400'} 
                                    py-1 px-2 text-white rounded-md`}
                            >
                                Download
                            </button>
                        )}
                    />
                </Table>
            </div>
            <Modal
                className="custom-download-modal bg-white py-2 rounded-lg"
                title={
                    <div className="text-lg font-semibold text-gray-800 mb-4">
                        Select Date Range for Download
                    </div>
                }
                visible={isDownloadModalVisible}
                onCancel={() => setIsDownloadModalVisible(false)}
                centered
                destroyOnClose
                bodyStyle={{

                    padding: '24px',

                    borderRadius: '0px'
                }}
                footer={[
                    <Button
                        key="cancel"
                        onClick={() => setIsDownloadModalVisible(false)}
                        className="mr-2"
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="download"
                        type="primary"
                        className="bg-blue-500 hover:bg-blue-600 transition-colors duration-300"
                        onClick={handleDownload}
                        disabled={!dateRange}
                    >
                        Download
                    </Button>
                ]}
            >
                <div className="space-y-2">
                    <p className="text-gray-600 mb-4">
                        Select the date range for which you want to download grievances.
                    </p>
                    <RangePicker
                        className="w-full py-2"
                        style={{
                            padding: '8px',
                            borderRadius: '8px',
                            border: '1px solid #d9d9d9'
                        }}
                        onChange={(dates) => setDateRange(dates)}
                        placeholder={['Start Date', 'End Date']}
                    />
                </div>
            </Modal>
        </>
    )
};

export default GmsClientDataTable;